import Cookies from 'universal-cookie'
import {WINDOW, DOCUMENT} from '../constants/environment'

const cookies = WINDOW && DOCUMENT && new Cookies()

export const getLocal = key => (WINDOW && WINDOW.localStorage.getItem(key)) || undefined
export const setLocal = (key, value) => WINDOW && WINDOW.localStorage.setItem(key, value)
const getCookie = key => cookies && cookies.get(key)
const setCookie = (key, value) => cookies && cookies.set(key, value, {path: '/'})

export const isLocalStorageSupported = () => {
  if (WINDOW.localStorage) {
    const test = '__localstoragetest__'
    try {
      WINDOW.localStorage.setItem(test, test)
      WINDOW.localStorage.removeItem(test)
    } catch (ex) {
      console.log('localStorage not supported!')
      return false
    }
    return true
  }
  return false
}

export const persist = props =>
  Object.keys(props).forEach((key) => {
    let value
    if (typeof props[key] === 'object') {
      value = JSON.stringify(props[key])
    } else {
      value = String(props[key])
    }
    setCookie(key, value)
    // localStorage doesn't work in iOS Safari private mode, hence the checking
    if (isLocalStorageSupported()) {
      setLocal(key, value)
    }
  })

export const load = (key) => {
  const fromCookie = getCookie(key)
  const fromLocal = getLocal(key)
  if (fromCookie) return fromCookie
  
  if (fromLocal) persist({[key]: fromLocal})
  if (typeof fromLocal === 'string') {
    try {
      return JSON.parse(fromLocal)
    } catch (error) {
      return fromLocal
    }
  }
}



// WEBPACK FOOTER //
// ./src/apis/persist.js